import { render } from "./tblVehCostAllocation.vue?vue&type=template&id=326eae1e"
import script from "./tblVehCostAllocation.vue?vue&type=script&lang=js"
export * from "./tblVehCostAllocation.vue?vue&type=script&lang=js"

import "./tblVehCostAllocation.vue?vue&type=style&index=0&id=326eae1e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__